module.exports = __webpack_public_path__ + "static/media/TRIAL 2-if-wrong.23fcb30a.mp3";